import { formatMonth, t } from '@glory/i18n';
import { addMonths, isMonth, type Month } from '@glory/sales/domain';
import type { ChoiceOption } from '@glory/ui';

/** «Сводка» живёт в адресе: выбранный месяц — ссылкой можно поделиться. */
export interface SummarySearch {
  /** Без значения — текущий месяц студии. */
  readonly month?: Month | undefined;
}

export function parseSummarySearch(search: Record<string, unknown>): SummarySearch {
  return { month: typeof search.month === 'string' && isMonth(search.month) ? search.month : undefined };
}

/** «Октябрь 2026». */
export function monthLabel(month: Month): string {
  const [year = '', number = '1'] = month.split('-');
  return `${formatMonth(Number(number))} ${year}`;
}

/** Месяцы для выбора: текущий и два года назад, свежие сверху. */
export function monthOptions(current: Month, back = 24): ChoiceOption[] {
  return Array.from({ length: back }, (_, i) => {
    const month = addMonths(current, -i);
    return { value: month, label: monthLabel(month) };
  });
}

/** Доля от целого в процентах, целым числом; пустое целое — 0. */
export function sharePercent(part: number, total: number): number {
  return total <= 0 ? 0 : Math.round((part / total) * 100);
}

/** Сравнение с прошлым месяцем одной строкой: «В прошлом месяце: 5» или «Как в прошлом месяце». */
export function previousText(now: number, before: number): string {
  return now === before ? t('sales.summary.previousEven') : t('sales.summary.previous', { value: before });
}
